import { render, staticRenderFns } from "./AlterarEmail.vue?vue&type=template&id=376a8e39&"
import script from "./AlterarEmail.vue?vue&type=script&lang=js&"
export * from "./AlterarEmail.vue?vue&type=script&lang=js&"
import style0 from "./AlterarEmail.vue?vue&type=style&index=0&id=376a8e39&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports